export default {
  addToCart: ({ commit }, product) => {
    commit('ADD_TO_CART', {
      product,
    });
  },
  removeOneFromCart: ({ commit }, product) => {
    commit('RMV_ONE_FROM_CART', {
      product,
    });
  },

  removeOneProductFromCart: ({ commit }, product) => {
    commit('RMV_ONE_PRODUCT_FROM_CART', {
      product,
    });
  },

  clearCart: ({ commit }) => {
    commit('CLEAR_CART');
  },

  addGivenQuantityOfAProduct: ({ commit }, { quantityAdded, product }) => {
    commit('ADD_GIVEN_QUANTITY', {
      quantityAdded,
      product,
    });
  },

  removeOneSupplierFromCart({ commit }, supplier) {
    commit('RMV_ONE_SUPPLIER_FROM_CART', {
      supplier,
    });
  },
};
